var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    我的套餐先隐藏, 接口已经对接完毕, 后期只要把 vuex 内的数据渲染出来即可\n")])}
var staticRenderFns = []

export { render, staticRenderFns }